import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import {
  BankReconciliationService,
  BankEnum,
  ColumnNameEnum,
} from '../../../service/bank-reconciliation.service';
import { bankOptions } from '../banks.list';
import { UserService } from '../../../service/user.service';

@Component({
  selector: 'app-pos-config',
  standalone: true,
  imports: [CommonModule, FormsModule, TabViewModule, ToastModule, ButtonModule, DropdownModule, InputTextModule],
  templateUrl: './pos-config.component.html',
  styleUrl: './pos-config.component.scss',
  providers: [MessageService]
})
export class PosConfigComponent implements OnInit {

  private readonly userService = inject(UserService);
  private readonly service = inject(BankReconciliationService);
  messageService = inject(MessageService);

  banks = signal(bankOptions);
  users = signal<any[]>([]);

  columnNameOptions: { label: string; value: ColumnNameEnum }[] = [
    { label: 'Transaction Date', value: 'TRANSACTION_DATE' },
    { label: 'Value Date', value: 'VALUE_DATE' },
    { label: 'Description', value: 'DESCRIPTION' },
    { label: 'Reference', value: 'REFERENCE' },
    { label: 'Debit', value: 'DEBIT' },
    { label: 'Credit', value: 'CREDIT' },
    { label: 'Balance', value: 'BALANCE' },
  ];

  allocationUser: number | null = null;
  allocationBank: BankEnum | null = null;
  posCode: string = '';

  configBank: BankEnum | null = null;
  regexPattern: string = '';
  configColumnName: ColumnNameEnum | null = null;

  savingAllocation = signal(false);
  savingConfig = signal(false);

  ngOnInit(): void {
    this.userService.listUsers({ pageNumber: 0, pageSize: 200 }).subscribe({
      next: (res) => this.users.set(Array.isArray(res) ? res : (res.users ?? res.content ?? [])),
      error: () => {},
    });
  }

  submitAllocation(): void {
    if (!this.allocationUser || !this.allocationBank || !this.posCode) return;
    this.savingAllocation.set(true);
    this.service.savePosAllocation({
      userId: this.allocationUser,
      bank: this.allocationBank,
      posCode: this.posCode,
    }).subscribe({
      next: (res) => {
        this.savingAllocation.set(false);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message ?? 'POS allocation saved' });
        this.allocationUser = null;
        this.allocationBank = null;
        this.posCode = '';
      },
      error: (err: any) => {
        this.savingAllocation.set(false);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message ?? 'Failed to save allocation' });
      },
    });
  }

  submitConfig(): void {
    if (!this.configBank || !this.regexPattern || !this.configColumnName) return;
    this.savingConfig.set(true);
    this.service.savePosConfig({
      bank: this.configBank,
      regexPattern: this.regexPattern,
      columnName: this.configColumnName,
    }).subscribe({
      next: (res) => {
        this.savingConfig.set(false);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message ?? 'POS configuration saved' });
        this.configBank = null;
        this.regexPattern = '';
        this.configColumnName = null;
      },
      error: (err: any) => {
        this.savingConfig.set(false);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message ?? 'Failed to save configuration' });
      },
    });
  }
}
